<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton" defaultHref="accounts"></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title">Application 4 - Quick Start</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list lines="none">
    </ion-list>
</ion-content>

<ion-footer>
</ion-footer>
